import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core'

import {
  FLX_MODAL_DATA,
  FlxButtonModule,
  FlxModalModule,
  FlxModalService,
} from '@flowx/angular-ui-toolkit'

@Component({
  selector: 'app-copy-paste-entity-confirmation-modal',
  imports: [FlxModalModule, FlxButtonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './copy-paste-entity-confirmation-modal.component.html',
})
export class CopyPasteEntityConfirmationModalComponent {
  #modalService = inject(FlxModalService)
  @Output() dataEventEmitter = new EventEmitter<void>()

  data = inject<{
    sourceEntities: string[]
    conflictedEntities: string[]
  }>(FLX_MODAL_DATA)

  modalTitle: string

  constructor() {
    const data = this.data

    this.modalTitle =
      data.sourceEntities?.length === 1
        ? `Paste ${data.sourceEntities[0]} Entity`
        : 'Paste Entities'
  }

  closeModal(): void {
    this.#modalService.hide()
  }

  confirm(): void {
    this.dataEventEmitter.emit()
  }
}
